import React, { useState, useEffect } from "react";
import { withStyles, Radio } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { images } from "../../utils/images";
import Selector2 from "../Selector2";

function AboutBusiness(props) {
  const { t, classes } = props;
  const [legalForm, setLegalForm] = useState("");
  const [otherLegalForm, setOtherLegalForm] = useState("");
  const [hasComplianceTeam, setHasComplianceTeam] = useState(null);
  const [teamSize, setTeamSize] = useState("");
  const [hasContractualReps, setHasContractualReps] = useState(null);
  const [reps, setReps] = useState("");
  const [hasEstoniaConnections, setHasEstoniaConnections] = useState(null);
  const [purposeOfCorporate, setPurposeOfCorporate] = useState("");
  const [otherPurpose, setOtherPurpose] = useState("");
  const [provideServicesToEEA, setProvideServicesToEEA] = useState(null);
  const [countriesProvided, setCountriesProvided] = useState("");
  const [mostImportantVendors, setMostImportantVendors] = useState("");
  const [acceptCash, setAcceptCash] = useState(null);
  const [shareholdersAbove25, setShareholdersAbove25] = useState(null);
  const [shareholdersNames, setShareholdersNames] = useState("");

  const [missingFields, setMissingFields] = useState([]);

  const legal_forms = [
    t("_soleProperty"),
    t("_partnership"),
    t("_corporation"),
    t("_llc"),
    t("_publicCompany"),
    t("_npo"),
    t("_other"),
  ];

  const acc_purposes = [
    t("_trading"),
    t("_investing"),
    t("_store_crypto"),
    t("_send_receive_crypto"),
    t("_other"),
  ];

  const aboutBusinessInputs = [
    {
      id: "legal_form",
      label: "_legalFormLabel",
      type: "selector",
      modifier: setLegalForm,
      value: legalForm,
      options: legal_forms,
      otherModifier: setOtherLegalForm,
      otherValue: otherLegalForm,
    },
    {
      id: "compliance_team_size",
      label: "_hasComplianceTeam",
      type: "bool",
      modifier: setHasComplianceTeam,
      value: hasComplianceTeam,
      secondary_input: {
        placeholder: "_ifHasTeam",
        value: teamSize,
        modifier: setTeamSize,
      },
    },
    {
      id: "contractual_representatives_names",
      label: "_hasContractualRepresentatives",
      type: "bool",
      modifier: setHasContractualReps,
      value: hasContractualReps,
      secondary_input: {
        placeholder: "_ifHasReps",
        value: reps,
        modifier: setReps,
      },
    },
    {
      id: "connections_with_estonia_present",
      label: "_hasConnectionsWithEstonia",
      type: "bool",
      modifier: setHasEstoniaConnections,
      value: hasEstoniaConnections,
      secondary_input: null,
    },
    {
      id: "purpose_of_account",
      label: "_purposeOfCorporate",
      type: "selector",
      modifier: setPurposeOfCorporate,
      value: purposeOfCorporate,
      options: acc_purposes,
      otherModifier: setOtherPurpose,
      otherValue: otherPurpose,
    },
    {
      id: "served_countries",
      label: "_provideServicesToEEA",
      type: "bool",
      modifier: setProvideServicesToEEA,
      value: provideServicesToEEA,
      secondary_input: {
        placeholder: "_ifProvidesServices",
        value: countriesProvided,
        modifier: setCountriesProvided,
      },
    },
    {
      id: "important_business_partners",
      label: "_mostImportantVendors",
      type: "text",
      placeholder: "_optional",
      modifier: setMostImportantVendors,
      value: mostImportantVendors,
    },
    {
      id: "cash_deposits_accepted",
      label: "_acceptCash",
      type: "bool",
      modifier: setAcceptCash,
      value: acceptCash,
      secondary_input: null,
    },
    {
      id: "major_shareholders_names",
      label: "_shareholdersAbove25",
      type: "bool",
      modifier: setShareholdersAbove25,
      value: shareholdersAbove25,
      secondary_input: {
        placeholder: "_ifShareholdersAbove25",
        modifier: setShareholdersNames,
        value: shareholdersNames,
      },
    },
  ];

  const validateDataAndProceed = async () => {
    const aboutBusinessObj = {
      legal_form:
        legalForm === ""
          ? null
          : legalForm === "Other"
          ? otherLegalForm === ""
            ? null
            : otherLegalForm.trim()
          : legalForm,
      compliance_team_size:
        hasComplianceTeam === true
          ? teamSize === ""
            ? null
            : Number(teamSize)
          : hasComplianceTeam === false
          ? 0
          : null,
      contractual_representatives_names:
        hasContractualReps === true
          ? reps === ""
            ? null
            : reps.trim()
          : hasContractualReps === false
          ? ""
          : null,
      connections_with_estonia_present:
        hasEstoniaConnections === true
          ? true
          : hasEstoniaConnections === false
          ? false
          : null,
      purpose_of_account:
        purposeOfCorporate === ""
          ? null
          : purposeOfCorporate === "Other"
          ? otherPurpose === ""
            ? null
            : otherPurpose.trim()
          : purposeOfCorporate,
      served_countries:
        provideServicesToEEA === true
          ? countriesProvided === ""
            ? null
            : countriesProvided.trim()
          : provideServicesToEEA === false
          ? ""
          : null,

      cash_deposits_accepted:
        acceptCash === true ? true : acceptCash === false ? false : null,
      major_shareholders_names:
        shareholdersAbove25 === true
          ? shareholdersNames === ""
            ? null
            : shareholdersNames.trim()
          : shareholdersAbove25 === false
          ? ""
          : null,
    };

    setMissingFields([]);
    let missingFieldsArr = [];

    Object.entries(aboutBusinessObj).map((entry) => {
      if (entry[1] === null) {
        missingFieldsArr.push(entry[0]);
      }
    });

    aboutBusinessObj.important_business_partners = mostImportantVendors.trim();

    if (missingFieldsArr.length) {
      setMissingFields([...missingFieldsArr]);

      props.pushNotification({ message: "missingFields", type: "error" });
      return;
    }

    await props.setAboutBusiness(aboutBusinessObj);
    await props.trigger(true);
  };

  return (
    <div className="corporateStepContainer">
      <h2 dangerouslySetInnerHTML={{ __html: t("_corporateT3") }} />
      <p>{t("_corporateP1")}</p>
      <div className={`inputsContainer ${classes.inputRows}`}>
        <div className="left">
          {aboutBusinessInputs.map((i, idx) => {
            if (i.type === "selector") {
              return (
                <div className="inputRow" key={idx}>
                  <p className="label">{t(i.label)}</p>
                  <Selector2
                    options={i.options}
                    selectorHandle={i.modifier}
                    selectedOption={i.value}
                    invalid={missingFields.includes(i.id) ? true : false}
                  />
                  {i.value === "Other" ? (
                    <input
                      type="text"
                      onChange={(e) => i.otherModifier(e.target.value)}
                      value={i.otherValue}
                      placeholder={t("_specify")}
                      style={{ marginBottom: 0, marginTop: 8 }}
                      className={
                        missingFields.includes(i.id) ? "invalidField" : ""
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
              );
            }

            if (i.type === "text") {
              return (
                <div className="inputRow" key={idx}>
                  <p className="label">{t(i.label)}</p>
                  <input
                    type={i.type}
                    placeholder={t(i.placeholder)}
                    value={i.value}
                    onChange={(e) => i.modifier(e.target.value)}
                    className={
                      missingFields.includes(i.id) ? "invalidField" : ""
                    }
                  />
                </div>
              );
            }

            if (i.type === "bool") {
              return (
                <div className="inputRow" key={idx}>
                  <p
                    className={`label ${
                      missingFields.includes(i.id) ? "invalidField" : ""
                    }`}
                  >
                    {t(i.label)}
                  </p>
                  <div className="radios">
                    <div className="radioSingle">
                      <Radio
                        classes={{
                          root: classes.radio,
                          checked: classes.checked,
                        }}
                        checked={
                          i.value === null ? false : i.value ? true : false
                        }
                        onClick={() => i.modifier(true)}
                      />
                      <span>{t("yes")}</span>
                    </div>
                    <div className="radioSingle">
                      <Radio
                        classes={{
                          root: classes.radio,
                          checked: classes.checked,
                        }}
                        checked={
                          i.value === null ? false : !i.value ? true : false
                        }
                        onClick={() => i.modifier(false)}
                      />
                      <span>{t("no")}</span>
                    </div>
                  </div>
                  {i.value && i.secondary_input ? (
                    <input
                      type={i.id === "compliance_team_size" ? "number" : "text"}
                      placeholder={t(i.secondary_input.placeholder)}
                      onKeyDown={
                        i.id === "compliance_team_size"
                          ? (evt) =>
                              evt.key === "e" ||
                              evt.key === "." ||
                              evt.key === "+" ||
                              evt.key === "-"
                                ? evt.preventDefault()
                                : ""
                          : () => {}
                      }
                      value={i.secondary_input.value}
                      onChange={(e) =>
                        i.secondary_input.modifier(e.target.value)
                      }
                      className={
                        missingFields.includes(i.id) ? "invalidField" : ""
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
              );
            }
          })}
        </div>
        <div className="right">
          <img src={images.illustrations.corpSolo3} />
        </div>
      </div>
      <div className="nextButtonContainer">
        <button onClick={() => validateDataAndProceed()}>{t("next")}</button>
      </div>
    </div>
  );
}

const styles = (theme) => ({
  radio: {
    color: theme.colors.text.primary,
    height: 30,
    "& svg": {
      fontSize: 20,
    },
  },
  checked: {
    color: `${theme.colors.buttons.green} !important`,
  },
  inputRows: {
    "& .inputRow": {
      marginBottom: 16,
      "& .label": {
        fontSize: 14,
        color: theme.colors.text.secondary,
        "&.invalidField": {
          color: `${theme.colors.buttons.sell} !important`,
        },
      },
      "& input": {
        ...theme.defaults.input,
        maxWidth: "none",
        marginBottom: 8,
        "&.invalidField": {
          borderColor: theme.colors.buttons.sell,
        },
      },

      "& .radios": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "50%",
        "& .radioSingle": {
          display: "flex",
          alignItems: "center",
          "& p": {
            marginLeft: 4,
          },
          "& span": {
            color: theme.colors.text.primary,
          },
        },
      },
    },
  },
});

export default withStyles(styles)(withTranslation()(AboutBusiness));
